import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { catchError, map } from "rxjs";
import { DropDownList } from "src/app/admin/models/common/drop-down-list";
import { SearchUserInputDto } from "src/app/admin/models/user-management-model";
import { UserManagementService } from "src/app/admin/services/user-management.service";
import { BaseComponent } from "src/app/shared/base/base-component";

@Component({
  selector: "app-user-filter",
  templateUrl: "./user-filter.component.html",
  styleUrls: ["./user-filter.component.scss"],
})
export class UserFilterComponent
  extends BaseComponent
  implements OnInit, OnDestroy
{
  @Input() searchModel: SearchUserInputDto;
  @Output() model = new EventEmitter<SearchUserInputDto | null>();

  public userTypes: DropDownList<number, string>[];
  public userStatus: DropDownList<number, string>[] = [
    { id: 1, name: "Active" },
    { id: 2, name: "Not Active" }
  ];
  public permissions: DropDownList<string, string>[];
  public displayedPermissions: DropDownList<string, string>[];

  constructor(
    private fb: FormBuilder,
    private userManagementService: UserManagementService
  ) {
    super();
  }

  ngOnInit() {
    this.createForm();
    this.translateStatuses();
    this.getUserTypes();
    this.getPermissions();
  }
  ngOnDestroy(): void {
    this.subscription.forEach((sb) => sb.unsubscribe());
  }
  private translateStatuses(): void {
    this.translate.get(['Global.Active', 'Global.InActive']).subscribe(translations => {
      this.userStatus = [
        { id: 1, name: translations['Global.Active'] },
        { id: 2, name: translations['Global.InActive'] }
      ];
    });
  }

  public getUserTypes(): void {
    const sub = this.userManagementService
      .GetUserTypesDDL()
      .pipe(
        map((response: DropDownList<number, string>[]) => {
          if (response) {
            this.userTypes = response;
          }
        }),
        catchError((err) => {
          return this.logException(err);
        })
      )
      .subscribe();

    this.subscription.push(sub);
  }
  public getPermissions(): void {
    const sub = this.userManagementService
      .GetPermissionsDDL()
      .pipe(
        map((response: DropDownList<string, string>[]) => {
          if (response) {
            this.permissions = response;
            this.displayedPermissions = response;
          }
        }),
        catchError((err) => {
          return this.logException(err);
        })
      )
      .subscribe();

    this.subscription.push(sub);
  }
  public onFilter() {
    if (!this.searchModel) this.searchModel = {} as SearchUserInputDto;

    const data = this.form_Group.controls;

    this.searchModel.name = data["name"].value;
    this.searchModel.surname = data["surname"].value;
    this.searchModel.email = data["email"].value;
    this.searchModel.mobile = data["mobile"].value;
    this.searchModel.userType = data["userType"].value;
    this.searchModel.userStatus = data["userStatus"].value;
    this.searchModel.jobID = data["jobId"].value;
    this.searchModel.permissions = data["permissions"].value;

    this.model.emit(this.searchModel);
  }
  public resetForm() {
    this.searchModel.name = "";
    this.searchModel.surname = "";
    this.searchModel.email = "";
    this.searchModel.mobile = "";
    this.searchModel.userType = null;
    this.searchModel.userStatus = null;
    this.searchModel.jobID = "";
    this.searchModel.permissions = null;
    this.createForm();
  }
  public selectPermission($event: DropDownList<string, string>[]) {
    const selectedPermissionIds = $event.map((item) => item.id);

    this.displayedPermissions = this.permissions.filter((permission) => {
      return !selectedPermissionIds.includes(permission.id);
    });
  }

  private createForm() {
    this.formGroup = this.fb.group({
      name: [this.searchModel?.name],
      surname: [this.searchModel?.surname],
      email: [this.searchModel?.email],
      mobile: [this.searchModel?.mobile],
      userType: [this.searchModel?.userType],
      userStatus: [this.searchModel?.userStatus],
      jobId: [this.searchModel?.jobID],
      permissions: [this.searchModel?.permissions],
    });

    this.formGroup.statusChanges.subscribe(() => {
      /* console.log("test ", result)*/
    });
  }
}
